import React from 'react';

interface TipProps {
  label: string;
  children: React.ReactNode;
}

const Tip: React.FC<TipProps> = ({ label, children }) => (
  <div className="bg-[var(--tip-bg)] border border-[var(--tip-border)] border-l-[3px] border-l-[var(--tip-accent)] rounded-[6px] px-[16px] py-[12px] my-[10px] text-[13px] text-[var(--tip-text)] leading-[1.6]">
    <span className="font-bold mr-[6px]">{label}</span>
    {children}
  </div>
);

export default Tip;
